import TicketCommentContent from 'gcs-common/components/Tickets/TicketComments/TicketCommentContent/TicketCommentContent';
import TicketMessageBubble from '../TicketMessageBubble/TicketMessageBuble';

interface TicketBotMessageProps {
  createdAt: string;
  html: string;
}

const TicketBotMessage = (props: TicketBotMessageProps) => {
  const { createdAt, html } = props;
  const parsedHtml = html.replace('<p><em>beem_bot:</em></p>\n\n', '');
  return (
    <TicketMessageBubble isFromMe={false} createdAt={createdAt}>
      <div className="font-medium text-neutral-11 text-sm">Beem Bot</div>
      <TicketCommentContent html={parsedHtml} />
    </TicketMessageBubble>
  );
};

export default TicketBotMessage;
